import { Injectable, inject } from '@angular/core';
import {ActivityInfosService} from './activity-infos.service';
import {YoungCurrentlyViewedService} from './young-currently-viewed.service';
import {FiltersService} from './filters.service';
import {TreeDataService} from './tree-data.service';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private readonly activity = inject(ActivityInfosService);
  private readonly young = inject(YoungCurrentlyViewedService);
  private readonly filter = inject(FiltersService);
  private readonly treeDataService = inject(TreeDataService);


  // Reset service stockage
  reset() {
    this.treeDataService.reset();
    this.activity.reset();
    this.filter.reset();
    this.young.reset();
  }
}
